// 金河项目专用：缓存 key 前缀，与山西项目隔离，避免同域名下读到山西缓存导致路由/菜单错乱
export const PROJECT_STORAGE_PREFIX = 'jinhe_'
export const sk = key => `${PROJECT_STORAGE_PREFIX}${key}`

// API 与文件服务地址由 .env.development/.env.test/.env.production 按构建模式注入。
export const BASE_SERVER_URL = process.env.VUE_APP_BASE_SERVER_URL || '/admin-api'
const DEFAULT_FILE_BASE_URL = process.env.VUE_APP_FILE_BASE_URL || ''

// 从 localStorage 的 user_model 中读取 filePrefix 静态文件访问前缀（可导出给组件拼接图片等静态资源 URL）
export function getFileBaseUrl() {
  try {
    const userModel = localStorage.getItem(sk('user_model')) // 使用金河项目缓存 key
    if (userModel && userModel.trim() !== 'null') {
      const modelData = JSON.parse(userModel)
      if (modelData && modelData !== null && modelData.filePrefix) {
        return modelData.filePrefix
      }else{
		  return DEFAULT_FILE_BASE_URL
	  }
    }else{
		return DEFAULT_FILE_BASE_URL
	}
  } catch (e) {
	  return DEFAULT_FILE_BASE_URL
  }
  return ''
}

// 创建一个对象，使用 valueOf 和 toString 方法，让对象在字符串拼接时自动调用 getter
// 这样 `${FILE_BASE_URL}${filePath}` 这种用法可以正常工作
const fileBaseUrlConfig = {
  valueOf() {
    return getFileBaseUrl()
  },
  toString() {
    return getFileBaseUrl()
  }
}
export const FILE_BASE_URL = fileBaseUrlConfig

export default {
  BASE_SERVER_URL,
  FILE_BASE_URL,
}
